/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AssessmentRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let page = this.modelFor('page').page;
    let assessment = store
      .findRecord('assessments/assessment', params.assessment_id)
      .then(
        (assessment) => {
          return assessment;
        },
        () => {
          return null;
        },
      );
    return hash({
      assessment,
      modules: store.query('assessments/module', {
        assessmentId: params.assessment_id,
      }),
      grades: store.query('assessments/grade', {
        assessmentId: params.assessment_id,
      }),
      page,
      assessmentPosts: this.store.query('posts/post', {
        assessmentId: params.assessment_id,
        include: 'reactions,comments',
        pageId: page.id,
      }),
    });
  }
}
